<div class="card">
    <div class="card-body">
        <div class="row">
            @for (group of actionLinks().groups; track group.id) {
                <div class="mb-3" [class]="group.columnClass">
                    <h4>{{ group.title }}</h4>
                    @if (group.wrapsIntoColumns) {
                        <div class="links">
                            <div class="link-container">
                                <ng-container *ngTemplateOutlet="linkList; context: { $implicit: group.links }">
                                </ng-container>
                            </div>
                        </div>
                    } @else {
                        <ng-container *ngTemplateOutlet="linkList; context: { $implicit: group.links }"></ng-container>
                    }
                </div>
            }
        </div>
    </div>
</div>

<ng-template #linkList let-links>
    @for (link of links; track link.id) {
        <div>
            @if (link.url) {
                <a class="pace-link btn btn-link" [href]="link.url" target="_blank">
                    <span>{{ link.label }}</span>
                </a>
            } @else {
                <button class="btn btn-link" [disabled]="link.isDisabled" (click)="actionSelect.emit(link)">
                    <span>{{ link.label }}</span>
                </button>
            }
        </div>
    }
</ng-template>
